// Import Turbo
import "@hotwired/turbo-rails";

// Import and register Stimulus with auto-registration
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";
import "cally";

// Register service worker for PWA
function registerServiceWorker() {
  window.addEventListener("load", () => {
    navigator?.serviceWorker
      .register("/service-worker")
      .then((registration) => {
        console.log("✅ Service worker registered:", registration);

        if (registration.installing) {
          console.log("🛠 Installing:", registration.installing);
        } else if (registration.waiting) {
          console.log("⏸ Waiting:", registration.waiting);
        } else if (registration.active) {
          console.log("🚀 Active:", registration.active);
        }
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  });
}

if ("serviceWorker" in navigator) {
  registerServiceWorker();
}

// Start Stimulus
const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// Auto-register all controllers in pwa directory
const controllers = import.meta.glob("../controllers/pwa/**/*_controller.js", {
  eager: true,
});
registerControllers(application, controllers);
